import React from "react";
import "./popupmenu.css";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import Account from "../user/account/Account";
import Recharge from "../user/recharge/Recharge";
import Withdraw from "../user/withdraw/WithDraw";
import HistoryRecharge from "../user/history/HistoryRecharge";
import HistoryWithdraw from "../user/history/HistoryWithdraw";
import HistoryBet from "../user/history/HistoryBet";
import Transfer from "../user/transfer/Transfer";
import axios from "axios";

const PopupMenu = ({ profile, isOpen, isClose, menuActive, getProfile }) => {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [activeOption, setActiveOption] = useState(0);
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };
    useEffect(() => {
        setActiveOption(menuActive);
    }, [menuActive]);
    const [bankCard, setBankCard] = useState(false);
    const menuClick = () => {
        setActiveOption(3);
        setBankCard(true);
    }
    return (
        <>
            {isOpen === true && profile != null && (
                <div className="backdrop">
                    <div className="menu-popup">
                        <div className="menu-popup-grid">
                            <div className="menu-sidebar">
                                <div className="menu-title">Thông tin tài khoản</div>
                                <div className="menu-sidebar-list">
                                    <ul>
                                        <li onClick={() => handleOptionClick(1)} className={`menu-sidebar-item ${activeOption == 1 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_securityCenter"></i>
                                            <span>Tài khoản</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(7)} className={`menu-sidebar-item ${activeOption == 7 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_rewardCenter"></i>
                                            <span>Chuyển ví</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(2)} className={`menu-sidebar-item ${activeOption == 2 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_depositv2"></i>
                                            <span>Nạp tiền</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(3)} className={`menu-sidebar-item ${activeOption == 3 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_withdraw"></i>
                                            <span>Rút tiền</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(4)} className={`menu-sidebar-item ${activeOption == 4 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_personalHistoryCopy"></i>
                                            <span>Lịch sử trò chơi</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(5)} className={`menu-sidebar-item ${activeOption == 5 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_transactionHistory"></i>
                                            <span>Lịch sử nạp tiền</span>
                                        </li>
                                        <li onClick={() => handleOptionClick(6)} className={`menu-sidebar-item ${activeOption == 6 ? "active" : ""}`}>
                                            <i className="acmc_icon icon_personalProfit"></i>
                                            <span>Lịch sử rút tiền</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="menu-content">
                                <div className="menu-content-box">
                                    {activeOption == 1 && <Account profile={profile} menuClick={menuClick} getProfile={getProfile} />}
                                    {activeOption == 2 && <Recharge profile={profile} getProfile={getProfile} />}
                                    {activeOption == 3 && <Withdraw profile={profile} bankCard={bankCard} getProfile={getProfile} />}
                                    {activeOption == 4 && <HistoryBet profile={profile} getProfile={getProfile} />}
                                    {activeOption == 5 && <HistoryRecharge profile={profile} getProfile={getProfile} />}
                                    {activeOption == 6 && <HistoryWithdraw profile={profile} getProfile={getProfile} />}
                                    {activeOption == 7 && <Transfer profile={profile} getProfile={getProfile} />}
                                </div>
                                <div className="close-popup" onClick={isClose}>
                                    <CloseIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PopupMenu;
